<template>
  <div class="drawer-progress">
    <Modal
      v-model="confirmChangeProgressModal"
      title="改变销售生产订单进度"
      @on-ok="confirmChangeProgress()"
      @on-cancel="confirmChangeProgressModal = false"
    >
      <p>
        确认销售生产订单进度为<span class="modalContentText">{{
          modalContentText
        }}</span
        >吗？
      </p>
    </Modal>
    <div>当前进度</div>
    <div class="progress-wrap">
      <div
        class="progress"
        @click="changeProgressMethod('finished')"
        style="left: 258px"
      >
        <div
          class="progress-content progress-border"
          :class="progressClass === 'finished' ? 'progress-content-active' : ''"
        >
          完成
        </div>
        <div
          class="progress-after"
          :class="progressClass === 'finished' ? 'progress-after-active' : ''"
        ></div>
      </div>
      <div
        class="progress"
        @click="changeProgressMethod('shipping')"
        style="left: 198px"
      >
        <div
          class="progress-content progress-border"
          :class="
            progressClass === 'shipping' || progressClass === 'finished'
              ? 'progress-content-active'
              : ''
          "
        >
          运输
        </div>
        <div
          class="progress-after"
          :class="
            progressClass === 'shipping' || progressClass === 'finished'
              ? 'progress-after-active'
              : ''
          "
        ></div>
      </div>
      <div
        class="progress"
        @click="changeProgressMethod('producing')"
        style="left: 137px"
      >
        <div
          class="progress-content progress-border"
          :class="
            progressClass != 'created' && progressClass != 'confirmed'
              ? 'progress-content-active'
              : ''
          "
        >
          生产
        </div>
        <div
          class="progress-after"
          :class="
            progressClass != 'created' && progressClass != 'confirmed'
              ? 'progress-after-active'
              : ''
          "
        ></div>
      </div>
      <div
        class="progress"
        style="left: 77px"
        @click="changeProgressMethod('confirmed')"
      >
        <div
          class="progress-content progress-border"
          :class="progressClass != 'created' ? 'progress-content-active' : ''"
        >
          确认
        </div>
        <div
          class="progress-after"
          :class="progressClass != 'created' ? 'progress-after-active' : ''"
        ></div>
      </div>
      <div class="progress" @click="changeProgressMethod('created')">
        <div
          class="progress-content"
          style="border-color: #31a6ff; color: #31a6ff"
        >
          提交
        </div>
        <div
          class="progress-after"
          style="
            color: #31a6ff;
            border-color: transparent transparent transparent #31a6ff;
          "
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "SalesProdProgress",
  props: ["selectedRecipeDetail", "currentSalesOrder"],
  data() {
    return {
      confirmChangeProgressModal: false,
      currentProgress: null,
      modalContentText: "",
      confirmedActive: false,
      producingActive: false,
      shippingActive: false,
      finishedActive: false,
      changeProgress: null,
    };
  },
  computed: {
    progressClass: function () {
      if (this.currentSalesOrder) {
        switch (this.currentSalesOrder.progress) {
          case "created":
            return (this.currentProgress = "created");
          case "confirmed":
            return (this.currentProgress = "confirmed");
          case "producing":
            return (this.currentProgress = "producing");
          case "halt":
            return (this.currentProgress = "halt");
          case "shipping":
            return (this.currentProgress = "shipping");
          case "finished":
            return (this.currentProgress = "finished");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      updateSalesProdOrder: "salesOrder/updateSalesProdOrderAction",
    }),
    async changeProgressMethod(progress) {
      this.changeProgress = progress;
      this.currentProgress = this.currentSalesOrder.progress;
      switch (progress) {
        case "created":
          break;
        case "confirmed":
          this.modalContentText = "确认";
          break;
        case "producing":
          this.modalContentText = "生产";
          break;
        case "shipping":
          this.modalContentText = "运输";
          break;
        case "finished":
          this.modalContentText = "完成";
          break;
      }
      this.confirmChangeProgressModal = true;
    },
    async confirmChangeProgress() {
      const data = await this.updateSalesProdOrder({
        id: this.currentSalesOrder._id,
        data: { progress: this.changeProgress },
      });
      this.currentSalesOrder.progress = data.progress;
      switch (this.changeProgress) {
        case "created":
          this.confirmedActive = false;
          this.producingActive = false;
          this.shippingActive = false;
          this.finishedActive = false;
          this.modalContentText = "提交";
          break;
        case "confirmed":
          this.confirmedActive = true;
          this.producingActive = false;
          this.shippingActive = false;
          this.finishedActive = false;
          this.modalContentText = "确认";
          break;
        case "producing":
          this.confirmedActive = true;
          this.producingActive = true;
          this.shippingActive = false;
          this.finishedActive = false;
          this.modalContentText = "生产";
          break;
        case "shipping":
          this.confirmedActive = true;
          this.producingActive = true;
          this.shippingActive = true;
          this.finishedActive = false;
          this.modalContentText = "运输";
          break;
        case "finished":
          this.confirmedActive = true;
          this.producingActive = true;
          this.shippingActive = true;
          this.finishedActive = true;
          this.modalContentText = "完成";
          break;
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.progress, .progress-wrap
  display flex

.progress
  position absolute
  cursor pointer

.progress-content
  width 60px
  height 30px
  background white
  border 1px solid lightgray
  border-right none
  line-height 29px
  // text-align center
  padding-left 20px

.progress-content-active
  color #31a6ff
  border-color #31a6ff

.progress-border
  border-left none

.progress-after
  width 0px
  height 0px
  position relative
  box-sizing border-box
  right 0px
  top 0px
  border-style solid
  border-width 14px 0px 15px 15px
  border-color transparent transparent transparent lightgray

.progress-after-active
  color #31a6ff
  border-color transparent transparent transparent #31a6ff

.progress-after:after
  content ''
  width 0px
  height 18px
  position absolute
  box-sizing border-box
  right 2px
  top -14px
  border-style solid
  border-width 14px 0px 15px 15px
  border-color transparent transparent transparent #fff

.modalContentText
  font-weight bold
</style>